import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-720f4315"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card border-0 rounded-2 shadow-sm bg-white mb-4" }
const _hoisted_2 = { class: "card-header bg-light py-3 px-4 border-0 d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "badge bg-success-subtle text-success fw-semibold fs-13 px-3 py-2" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row gy-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-home me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Identidad legal ")
  ])
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Razón social *", -1))
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Nombre comercial", -1))
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Nombre corto", -1))
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Tipo documento", -1))
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "NIT", -1))
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Código DANE", -1))
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Registro educativo", -1))
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "No. Resolución", -1))
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Fecha Resolución", -1))
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-private-entity"
}, " ¿Es entidad privada? ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-none d-md-block" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-phone-call me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Contacto ")
  ])
], -1))
const _hoisted_29 = { class: "col-md-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Teléfono 1", -1))
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Teléfono 2", -1))
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Celular", -1))
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Email", -1))
const _hoisted_37 = { class: "col-md-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Sitio web", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 d-none d-md-block" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-map me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Dirección ")
  ])
], -1))
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Dirección línea 1", -1))
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Dirección línea 2", -1))
const _hoisted_45 = { class: "col-md-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Barrio / Sector", -1))
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Ciudad", -1))
const _hoisted_49 = { class: "col-md-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Departamento / Estado", -1))
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "País", -1))
const _hoisted_53 = { class: "col-md-3" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Código postal", -1))
const _hoisted_55 = { class: "col-md-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Latitud", -1))
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Longitud", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-none d-md-block" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Adjuntos ")
  ])
], -1))
const _hoisted_61 = { class: "col-md-6" }
const _hoisted_62 = { class: "attach-card border border-secondary-subtle rounded-2 p-3" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Logo institucional "),
    /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "Se verá en reportes/encabezados")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-light text-secondary" }, "PNG/JPG")
], -1))
const _hoisted_64 = { class: "d-flex align-items-center gap-3" }
const _hoisted_65 = { class: "thumb-wrapper" }
const _hoisted_66 = ["src"]
const _hoisted_67 = {
  key: 1,
  class: "thumb-placeholder"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-image" }, null, -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "flex-grow-1" }
const _hoisted_71 = { class: "text-muted small mb-1" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Actual:", -1))
const _hoisted_73 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nuevo:", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-upload me-1" }, null, -1))
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = { class: "attach-card border border-secondary-subtle rounded-2 p-3" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-dark" }, [
    /*#__PURE__*/_createTextVNode(" Firma del director "),
    /*#__PURE__*/_createElementVNode("div", { class: "text-muted small" }, "Ideal en PNG con fondo transparente")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-light text-secondary" }, "PNG/JPG")
], -1))
const _hoisted_79 = { class: "d-flex align-items-center gap-3" }
const _hoisted_80 = { class: "thumb-wrapper" }
const _hoisted_81 = ["src"]
const _hoisted_82 = {
  key: 1,
  class: "thumb-placeholder"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-edit" }, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { class: "flex-grow-1" }
const _hoisted_86 = { class: "text-muted small mb-1" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Actual:", -1))
const _hoisted_88 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nuevo:", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-upload me-1" }, null, -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Representante legal ")
  ])
], -1))
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Nombre", -1))
const _hoisted_94 = { class: "col-md-4" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Tipo documento", -1))
const _hoisted_96 = { class: "col-md-4" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Número documento", -1))
const _hoisted_98 = { class: "col-md-3" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Teléfono", -1))
const _hoisted_100 = { class: "col-md-3" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Email", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-none d-md-block" }, null, -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-none d-md-block" }, null, -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-id-card me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Director(a) / Rector(a) ")
  ])
], -1))
const _hoisted_105 = { class: "col-md-4" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Nombre", -1))
const _hoisted_107 = { class: "col-md-4" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Tipo documento", -1))
const _hoisted_109 = { class: "col-md-4" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Número documento", -1))
const _hoisted_111 = { class: "col-md-3" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Teléfono", -1))
const _hoisted_113 = { class: "col-md-3" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Email", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-none d-md-block" }, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 d-none d-md-block" }, null, -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-2" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "section-title" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Textos para reportes ")
  ])
], -1))
const _hoisted_118 = { class: "col-md-6" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Encabezado línea 1", -1))
const _hoisted_120 = { class: "col-md-6" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Encabezado línea 2", -1))
const _hoisted_122 = { class: "col-md-6" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Pie de página línea 1", -1))
const _hoisted_124 = { class: "col-md-6" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Pie de página línea 2", -1))
const _hoisted_126 = { class: "col-12 mt-4 d-flex justify-content-between align-items-center" }
const _hoisted_127 = {
  key: 1,
  class: "flaticon-save me-2"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.form.record.LegalName ? _ctx.form.record.LegalName : ""), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_b_form, {
        ref: "formRecord",
        id: "formSchoolLegalEntity",
        onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_container, { fluid: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.LegalName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.LegalName) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Institución Educativa Aurora",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.TradeName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.TradeName) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Colegio Aurora"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ShortName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.ShortName) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Aurora"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.TaxIdType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.TaxIdType) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: NIT"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.TaxId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.TaxId) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: 900123456-7"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.DANECode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.DANECode) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Opcional"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.EducationRegistryNo,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.EducationRegistryNo) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Licencia / Registro"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ResolutionNumber,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.record.ResolutionNumber) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: 1234"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ResolutionDate,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.record.ResolutionDate) = $event)),
                    type: "date",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_b_form_radio_group, {
                    id: "input-private-entity",
                    name: "private-entity",
                    size: "sm",
                    modelValue: _ctx.privateEntityProxy,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.privateEntityProxy) = $event)),
                    options: _ctx.privateEntityOptions,
                    buttons: "",
                    "button-variant": "outline-success",
                    class: "d-flex gap-2 transport-radio"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _hoisted_27,
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Phone1,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.record.Phone1) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: (602) 123 4567"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Phone2,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.record.Phone2) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _hoisted_34,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Mobile,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.record.Mobile) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Email,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.record.Email) = $event)),
                    type: "email",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "contacto@colegio.com"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Website,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.record.Website) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "https://..."
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_39,
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.AddressLine1,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.record.AddressLine1) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Calle / Carrera / etc."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.AddressLine2,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.record.AddressLine2) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Neighborhood,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.record.Neighborhood) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.City,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.record.City) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.StateProvince,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.record.StateProvince) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Country,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.record.Country) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.PostalCode,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.record.PostalCode) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Latitude,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.record.Latitude) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "(texto)"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Longitude,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.record.Longitude) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "(texto)"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_59,
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        (_ctx.logoAttachment.previewUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.logoAttachment.previewUrl,
                              class: "thumb-img",
                              alt: "Logo"
                            }, null, 8, _hoisted_66))
                          : (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69))
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _hoisted_72,
                          _createTextVNode(" " + _toDisplayString(_ctx.form.record.LogoFile || "No asignado"), 1)
                        ]),
                        (_ctx.logoAttachment.file)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                              _hoisted_74,
                              _createTextVNode(" " + _toDisplayString(_ctx.logoAttachment.file.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("input", {
                          ref: "logoInput",
                          type: "file",
                          accept: "image/*",
                          class: "visually-hidden",
                          onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onAttachmentChange($event, 'logo')))
                        }, null, 544),
                        _createElementVNode("a", {
                          href: "#",
                          class: "upload-link mt-2 d-inline-block",
                          onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.openFileDialog('logo')), ["prevent"]))
                        }, [
                          _hoisted_75,
                          _createTextVNode(" Subir imagen ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        (_ctx.signatureAttachment.previewUrl)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.signatureAttachment.previewUrl,
                              class: "thumb-img",
                              alt: "Firma"
                            }, null, 8, _hoisted_81))
                          : (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _hoisted_87,
                          _createTextVNode(" " + _toDisplayString(_ctx.form.record.DirectorSignatureFile || ""), 1)
                        ]),
                        (_ctx.signatureAttachment.file)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                              _hoisted_89,
                              _createTextVNode(" " + _toDisplayString(_ctx.signatureAttachment.file.name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("input", {
                          ref: "signatureInput",
                          type: "file",
                          accept: "image/*",
                          class: "visually-hidden",
                          onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.onAttachmentChange($event, 'signature')))
                        }, null, 544),
                        _createElementVNode("a", {
                          href: "#",
                          class: "upload-link mt-2 d-inline-block",
                          onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.openFileDialog('signature')), ["prevent"]))
                        }, [
                          _hoisted_90,
                          _createTextVNode(" Subir imagen ")
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_91,
                _createElementVNode("div", _hoisted_92, [
                  _hoisted_93,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RepresentativeName,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.record.RepresentativeName) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _hoisted_95,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RepresentativeIdType,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.record.RepresentativeIdType) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _hoisted_97,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RepresentativeIdNumber,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.record.RepresentativeIdNumber) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _hoisted_99,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RepresentativePhone,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.record.RepresentativePhone) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_100, [
                  _hoisted_101,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RepresentativeEmail,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.form.record.RepresentativeEmail) = $event)),
                    type: "email",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_102,
                _hoisted_103,
                _hoisted_104,
                _createElementVNode("div", _hoisted_105, [
                  _hoisted_106,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.DirectorName,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.record.DirectorName) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.DirectorIdType,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.form.record.DirectorIdType) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _hoisted_110,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.DirectorIdNumber,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.form.record.DirectorIdNumber) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  _hoisted_112,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.DirectorPhone,
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.form.record.DirectorPhone) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_113, [
                  _hoisted_114,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.DirectorEmail,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.form.record.DirectorEmail) = $event)),
                    type: "email",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_115,
                _hoisted_116,
                _hoisted_117,
                _createElementVNode("div", _hoisted_118, [
                  _hoisted_119,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ReportHeaderLine1,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.form.record.ReportHeaderLine1) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_120, [
                  _hoisted_121,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ReportHeaderLine2,
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.form.record.ReportHeaderLine2) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_122, [
                  _hoisted_123,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ReportFooterLine1,
                    "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.form.record.ReportFooterLine1) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_124, [
                  _hoisted_125,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ReportFooterLine2,
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.form.record.ReportFooterLine2) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_126, [
                  _createVNode(_component_b_button, {
                    class: "default-btn border-0 fw-semibold text-white px-4 py-2 bg-success",
                    type: "submit",
                    disabled: _ctx.form.saving
                  }, {
                    default: _withCtx(() => [
                      (_ctx.form.saving)
                        ? (_openBlock(), _createBlock(_component_b_spinner, {
                            key: 0,
                            small: "",
                            class: "me-2"
                          }))
                        : (_openBlock(), _createElementBlock("i", _hoisted_127)),
                      _createTextVNode(" Guardar ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_b_button, {
                    onClick: _ctx.reload,
                    class: "bg-transparent border-0 text-secondary fw-semibold",
                    type: "button"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_128,
                      _createTextVNode(" Recargar ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}